<div class="error-block">
  <app-logo></app-logo>
  <div class="error-role-block">
    <i class="pi pi-times-circle"></i>
    <p>Отсутствуют права по работе с документами</p>
  </div>
</div>
